var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h6',{staticClass:"mt-2 pt-50 mb-1"},[_vm._v(" "+_vm._s(_vm.monthFormat.charAt(0).toUpperCase() + _vm.monthFormat.slice(1))+" ")]),_c('b-list-group',_vm._l((_vm.itemsSorted),function(item){return _c('history-day-item',{key:item.date,attrs:{"item":item}})}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }